<div class="flex-direction-column disparos-page page" [style.height]="gerarAlturaComponent()">
  @if (!adicaoDisparo){
    <app-tabela-disparo-automatico class="" [statusGroup]="statusGroup" [programacaoId]="programacaoId" [textoVazio]="statusGroup === 'PROGRAMACOES' ? 'Nenhuma programação encontrada.' : 'Nenhum disparo encontrado.'" (abrirCriacao)="abrirAdicao()" [ehMobile]="ehMobile" [isHml]="isHml" (disparoAutomaticoSelecionado)="disparoAutomaticoSelecionado($event)"></app-tabela-disparo-automatico>
  } @else {
    @if (carregandoCadastro) {
      <app-cadastro-disparo-automatizado
        [ehMobile]="ehMobile"
        [carregandoInicialCadastro]="true"
        [exibirProgramacao]="statusGroup === 'PROGRAMACOES'">
      </app-cadastro-disparo-automatizado>
    } @else {
      <app-cadastro-disparo-automatizado class="" [ehMobile]="ehMobile" [exibirProgramacao]="statusGroup === 'PROGRAMACOES'" [tipoProgramacaoInicial]="tipoProgramacaoInicial" [programacaoInicial]="programacaoSelecionada" [disparoAutomatico]="disparoAutomatico" (cancelar)="fecharCadastro()"></app-cadastro-disparo-automatizado>
    }
  }
</div>
